export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const gtagId = config.public.gtagId;

  if (!gtagId) return;

  // Cargar script GA
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
  document.head.appendChild(script);

  // Inicializar dataLayer
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", gtagId, {
    send_page_view: false, // <-- Desactiva page_view automático
  });

  // Tracking SPA manual
  nuxtApp.hook("page:finish", () => {
    window.gtag("event", "page_view", {
      page_path: window.location.pathname,
    });
  });

  // Inyección Nuxt
  return {
    provide: {
      gtag: window.gtag,
    },
  };
});
